import React, { useRef, useEffect } from 'react';
import {
    StepperWrapper,
    StepperInner,
    StepperTrack,
    StepNode,
    NodeCircle,
    CarNode,
    StepLabel,
    SegmentWrapper,
    Segment,
    SegmentArrow,
    CancelAction,
    DeliveryIdLabel,
} from './styles';

const CarIcon = () => (
    <svg width="20" height="14" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 10h2l1.5-4 2-2h9l2 2 1.5 4h2v2h-1.5a1.5 1.5 0 01-3 0h-9a1.5 1.5 0 01-3 0H1v-2z"
            fill="currentColor"
        />
        <circle cx="6" cy="11" r="1.5" fill="currentColor" />
        <circle cx="18" cy="11" r="1.5" fill="currentColor" />
    </svg>
);

const CancelIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export default function DeliveryCreationStepper({ steps, currentStep, onStepClick, onCancel, deliveryId }) {
    const activeStepRef = useRef(null);

    useEffect(() => {
        if (activeStepRef.current) {
            activeStepRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [currentStep]);

    return (
        <StepperWrapper>
            <StepperInner>
                <StepperTrack>
                    {steps.map((label, index) => {
                        const isActive = index === currentStep;
                        const passed = index < currentStep;
                        const segmentLeadsToCurrent = index === currentStep && currentStep > 0;
                        return (
                            <React.Fragment key={index}>
                                {index > 0 && (
                                    <SegmentWrapper>
                                        <Segment $passed={passed} $showArrow={segmentLeadsToCurrent} />
                                        {segmentLeadsToCurrent && <SegmentArrow />}
                                    </SegmentWrapper>
                                )}
                                <StepNode
                                    ref={isActive ? activeStepRef : undefined}
                                    type="button"
                                    onClick={() => onStepClick?.(index)}
                                    title={`Ir para: ${label}`}
                                >
                                    {isActive ? (
                                        <CarNode>
                                            <CarIcon />
                                        </CarNode>
                                    ) : (
                                        <NodeCircle $active={false} $passed={passed}>
                                            {index + 1}
                                        </NodeCircle>
                                    )}
                                    <StepLabel>{label}</StepLabel>
                                </StepNode>
                            </React.Fragment>
                        );
                    })}
                </StepperTrack>
                {onCancel && (
                    <CancelAction type="button" onClick={onCancel} title="Cancelar e voltar à lista de entregas">
                        <CancelIcon />
                        Cancelar entrega
                    </CancelAction>
                )}
            </StepperInner>
            {deliveryId && (
                <DeliveryIdLabel>Entrega #{deliveryId}</DeliveryIdLabel>
            )}
        </StepperWrapper>
    );
}
